var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.08 189.4 28.58 233.87A28 28 0 0 0 72.52 448h367a28 28 0 0 0 27.86-24.73l28.54-233.87A12 12 0 0 0 484 176H28a12 12 0 0 0-11.92 13.4zM464 124a28 28 0 0 0-28-28H244.84l-48-32H76a28 28 0 0 0-28 28v52h416z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.08 447.224c-10.523-1.773-19.358-9.825-22.088-20.132-1.226-4.63-29.375-234.02-29.375-239.385 0-3.657 1.805-6.952 5.178-9.451l1.997-1.48H488.154l1.996 1.48c3.446 2.553 5.178 5.781 5.178 9.648 0 4.32-27.978 234.427-29.04 238.835-2.497 10.376-11.838 18.693-23.059 20.53-5.028.824-370.254.78-375.148-.045z",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#fffffb",
      fillOpacity: 1,
      strokeWidth: 0.707107,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.437 116.04c0-25.797.103-28.188 1.402-32.35 2.465-7.898 8.638-14.405 16.783-17.693l4.089-1.65 62.715-.209 62.716-.209 24.427 16.296 24.428 16.295h97.96c95.162 0 98.07.04 101.865 1.373 8.21 2.885 14.775 9.577 17.284 17.617 1.166 3.736 1.402 6.509 1.402 16.44v11.946H48.437Z",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.707107,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.438 103.629a28.332 28.332 0 0 0-9.568-5.731c-1.286-.455-2.37-.654-4.453-.814-4.11-.316-11.4-.439-31.063-.522l-3.464-.014V96h15.054c8.944 0 15.343.01 15.767.022a27.995 27.995 0 0 1 16.15 5.64c.601.453.94.732 1.8 1.48.04.033.043.063.037.377l-.006.34z",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#444",
      fillOpacity: 1,
      strokeWidth: 0.0220971,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.53 134.406c-.001-8.895-.085-11.77-.42-14.419a24.055 24.055 0 0 0-.95-4.37 26.62 26.62 0 0 0-4.991-9.152 34.153 34.153 0 0 0-2.033-2.202l-.425-.407.026-.309.025-.31 1.038 1.04c2.258 2.257 3.841 4.461 5.255 7.313a27.663 27.663 0 0 1 2.872 10.762c.028.454.045 3.968.045 9.313v8.585h-.441z",
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "#444",
      fillOpacity: 1,
      strokeWidth: 0.0441942,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000",
      stopOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.28a95eb6bb73b3d3e6464b4f86e04b0e.svg";
export { ForwardRef as ReactComponent };